// Proppe — App-wide constants
// IMPORTANT: This file ships to the browser. Never put secrets here
// (API keys, JWT secrets, DB passwords). Only public configuration.

export const CONSTANTS = {
  VERSION: '0.1.0',

  // Backend API base URL (Railway).
  // TODO: Replace with your actual Railway URL before deploy.
  API_BASE: 'https://api.proppe.co.in',

  // Admin contact (for "Talk to us" button / WhatsApp).
  // TODO: Replace with actual admin phone number (with country code, no +).
  ADMIN_NUM: '91XXXXXXXXXX',

  // Live HTML site (we link to it during transition)
  LIVE_SITE_URL: 'https://proppe.co.in',

  // localStorage keys (centralized — easy to find/refactor later)
  STORAGE_KEYS: {
    SESSION: 'proppe_session',
    JWT: 'proppe_jwt',
    USER: 'proppe_user'
  },

  // Feature flags — flip to true as we ship modules
  FEATURES: {
    AUTH_ENABLED: false,    // turn on in Week 2
    ADMIN_PANEL: false,     // turn on in Week 3
    RM_DASHBOARD: false     // turn on in Week 3
  }
};
